module.exports = __webpack_public_path__ + "img/img (62).f73bf027.jpg";